import { Log } from './Log';
import { ILogger } from './ILogger';

export class Logger implements ILogger {
    private _toast: boolean;
    private _name: string;
    private _level: number;
    private _logs: Log[];

    constructor(private _console: Console, private _toastr: Toastr, name?: string) {
        this.toast(false);
        this._name = name ? name : 'Default';
        this._level = 0;
        this._logs = [];
    }

    debug(message: string): void {
        if (this.level() <= 0) {
            message = this.format(message, 'debug');
            this._console.log(message);
        }
    }

    info(message: string): void {
        if (this.level() <= 1) {
            message = this.format(message, 'info');
            this._console.info(message);
            if (this._toast) {
                this._toastr.info(message);
            }
        }
    }

    success(message: string): void {
        if (this.level() <= 2) {
            message = this.format(message, 'success');
            this._console.log(message);
            if (this._toast) {
                this._toastr.success(message);
            }
        }
    }

    warning(message: string): void {
        if (this.level() <= 3) {
            message = this.format(message, 'warning');
            this._console.warn(message);
            if (this._toast) {
                this._toastr.warning(message);
            }
        }
    }

    error(message: Error): void;
    error(message: string): void;
    error(message: any): void {
        //if (typeof(message) === 'Error') {
        //    message = message.name;
        //}
        if (message.name) {
            message = message.name;
        }
        if (this.level() <= 4) {
            message = this.format(message, 'error');
            this._console.error(message);
            if (this._toast) {
                this._toastr.error(message);
            }
        }
        if (message.stack) {
            this._console.error(message.stack);
        }
    }

    level(value?: number): number {
        if (value || value === 0) {
            this._level = value;
        }
        return this._level;
    }

    getLogs(): Log[] {
        return this._logs;
    }


    private format(message: string, level: string): string {
        const date = new Date();
        const dateString = date.toISOString();
        const levelString = level.toUpperCase();
        const result = `[${dateString}] - [${this._name}] - ${levelString} - ${message}`;
        this._logs.push(new Log(this._name, level, message, date));
        return result;
    }

    toast(value: boolean): void {
        this._toast = !!value;
    }

}
